import React, {useContext, Fragment} from 'react';
import {Activities, UI, TagsList, Collaboration, DateContext} from 'components';
import {Footer as DefaultFooter, Repetition} from '.';
import {noop, modal, size, shorten, pick, useNamedSelector} from 'helpers';
import moment from 'moment/moment';

export function Card({ id, style, ...props }) {
  const { Card } = UI;

  const details = {
    ...useNamedSelector('activities.details', { id, context: 'activities' }),
    ...props,
  }

  const { activity, editable, type, image, timeframe, status, disabled, context, occurance } = details;

  if (activity.dailyRoutineType && (activity.dailyRoutineType === 'time_block')) {
    style = {
      ...style,
      border: '1px solid var(--sidebar-color)'
    };
  }

  const {
    muted,
    Checkbox,
    Body = CardBody,
    Footer = DefaultFooter,
    Status = Collaboration.CardStatus,
    ActionMenu = Activities.MenuHandle,
  } = props;

  let contextDate = useContext(DateContext);
  if (!activity.repeatType && activity.ts) {
    contextDate = moment.unix(activity.ts);
  }

  const edit = modal(Activities.Single.EditForm, { id, ...context, occurance, contextDate });

  const attributes = {
    ...pick(activity, 'priority'),
    ...props,
    darkBackground: props.image ?? image,
    disabled,
    status,
    style,
    timeframe,
    [`is-${type}`]: true,
  }

  if (!attributes.navLink && attributes.onClick !== noop) {
    attributes.onClick = edit;
  }

  if (!editable || muted) {
    attributes.navLink =
    attributes.onClick =
    attributes.draggable =
    attributes.onDragStart = undefined;
  }

  return (
    <Card {...attributes} data-id={id}>
      <Status selector="activities.details" id={id} />

      { activity.googleEventId && activity.importedEvent &&
        <Card.Status>{ useNamedSelector('googleCalendar.calendarName', { id: activity.googleCalendarId }) }</Card.Status>
      }

      { activity.iOSEventId && activity.importedEvent &&
        <Card.Status>Apple</Card.Status>
      }

      { editable && Checkbox && <Checkbox id={id} {...details} /> }

      <ActionMenu {...details} {...{activity, id, attributes, contextDate, editable, disabled, edit}} />

      <Body {...activity} {...details} contextDate={contextDate} attributes={attributes} />

      { Footer &&
        <Footer contextDate={contextDate} {...details} />
      }
    </Card>
  );
}

function CardBody(props) {
  const { contextDate, detailed, timeframe, subtasks, subroutines, ...activity } = props;
  const { Card } = UI;
  return (
    <Card.Body>
      <Card.Text>{ activity.name }</Card.Text>
      <Card.Note>{ shorten(activity.note, { words: 30 }) }</Card.Note>

      { detailed !== false &&
        <Fragment>
          <TagsList values={activity.tagIds} unclickable className="small" />
          { size(subtasks) > 0 &&
            <Activities.SubTasksChecklist {...props} detailed />
          }
          { size(subroutines) > 0 &&
            <Activities.SubRoutinesChecklist {...props} detailed />
          }
        </Fragment>
      }

      { timeframe != 'muted' && parseFloat(activity.numericalTarget) > 0 && contextDate &&
        <Activities.TrackProgress activity={activity} contextDate={contextDate} />
      }
    </Card.Body>
  );
}

Card.Footer = DefaultFooter;
Card.Repetition = Repetition;
